module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_statistics_for_users.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_statistics_for_users.png
// module id = rf7W
// module chunks = 0